import React from 'react';

const NetworkDetailsModal = ({
    isOpen,
    onClose,
    initiatorEntries,
    resourceEntries,
    tableHeaderStyle,
    tableCellStyle,
    formatValue
}) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(7, 7, 10, 0.92)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10000,
                padding: '24px'
            }}
            onClick={onClose}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '1200px',
                    maxHeight: '860px',
                    backgroundColor: '#121212',
                    borderRadius: '10px',
                    boxShadow: '0 18px 60px rgba(0, 0, 0, 0.55)',
                    border: '1px solid rgba(100, 181, 246, 0.35)',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '14px',
                        right: '14px',
                        backgroundColor: 'rgba(220, 53, 69, 0.92)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '42px',
                        height: '42px',
                        fontSize: '24px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 8px 20px rgba(220, 53, 69, 0.45)',
                        transition: 'transform 0.2s ease, background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'rgba(207, 46, 60, 0.95)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'rgba(220, 53, 69, 0.92)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ×
                </button>
                <div
                    style={{
                        flex: 1,
                        overflow: 'auto',
                        backgroundColor: '#0c0c0c',
                        padding: '24px'
                    }}
                >
                    <h3
                        style={{
                            margin: '0 0 24px 0',
                            color: '#e0e0e0',
                            fontWeight: '600'
                        }}
                    >
                        Network Details
                    </h3>

                    {initiatorEntries.length > 0 && (
                        <div
                            style={{
                                marginBottom: '30px',
                                backgroundColor: '#181818',
                                borderRadius: '8px',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                padding: '20px'
                            }}
                        >
                            <h4
                                style={{
                                    margin: '0 0 16px 0',
                                    color: '#d8d8d8',
                                    fontWeight: '600'
                                }}
                            >
                                Requests by Initiator
                            </h4>
                            <div style={{ overflowX: 'auto' }}>
                                <table
                                    style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        minWidth: '320px'
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>Initiator</th>
                                            <th style={tableHeaderStyle}>Requests</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {initiatorEntries.map(([type, count]) => (
                                            <tr key={type}>
                                                <td style={tableCellStyle}>{type.replace(/_/g, ' ')}</td>
                                                <td style={tableCellStyle}>{count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {resourceEntries.length > 0 && (
                        <div
                            style={{
                                backgroundColor: '#181818',
                                borderRadius: '8px',
                                border: '1px solid rgba(100, 181, 246, 0.12)',
                                padding: '20px'
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '16px'
                                }}
                            >
                                <h4
                                    style={{
                                        margin: 0,
                                        color: '#d8d8d8',
                                        fontWeight: '600'
                                    }}
                                >
                                    Resource Requests
                                </h4>
                                <span
                                    style={{
                                        fontSize: '12px',
                                        color: '#9a9a9a'
                                    }}
                                >
                                    {resourceEntries.length} entries
                                </span>
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table
                                    style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        minWidth: '720px'
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={tableHeaderStyle}>Name</th>
                                            <th style={tableHeaderStyle}>Initiator</th>
                                            <th style={tableHeaderStyle}>Duration (ms)</th>
                                            <th style={tableHeaderStyle}>Start Time (ms)</th>
                                            <th style={tableHeaderStyle}>Transfer Size (bytes)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resourceEntries.map((entry, index) => (
                                            <tr key={`${entry.name}-${index}`}>
                                                <td
                                                    style={{
                                                        ...tableCellStyle,
                                                        maxWidth: '320px',
                                                        wordBreak: 'break-word'
                                                    }}
                                                >
                                                    {entry.name}
                                                </td>
                                                <td style={tableCellStyle}>{entry.initiatorType}</td>
                                                <td style={tableCellStyle}>{formatValue(entry.duration)}</td>
                                                <td style={tableCellStyle}>{formatValue(entry.startTime)}</td>
                                                <td style={tableCellStyle}>{formatValue(entry.transferSize)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NetworkDetailsModal;








